import classNames from "classnames";
import { connectRefinementList } from "react-instantsearch-dom";
import React from "react";

const RefinementList = ({ items, refine }) => (
	<ul className="ps-0">
		{items.map((item, idx) => (
			<li key={item.label} className="list-unstyled">
				<a
					href="#"
					onClick={(event) => {
						event.preventDefault();
						refine(item.value);
					}}
					className={classNames(
						"d-flex justify-content-between py-1 text-decoration-none",
						{
							"border-bottom": items.length !== idx + 1,
							"text-black-50": !item.isRefined,
							"text-success": item.isRefined,
						}
					)}
				>
					<span>{item.label}</span>
					<span>{item.isRefined ? "x" : item.count}</span>
				</a>
			</li>
		))}
	</ul>
);

export default connectRefinementList(RefinementList);
